<template>
  <div class="monitor_wrap">
    <div class="mainHead">
      <div class="route">
        <span class="crumbs"></span><span class="router_link" @click="linkIndex">{{firstTipTitle}}</span><span>></span><span class="router_link" @click="linkDetail">报警详情</span><span>></span><span>{{tipTitle}}</span>
      </div>
      <div v-if="!isExamineUrl&&!isSearchWarnUrl">
        <el-button type="primary" @click="editForm" v-show="showEditAndDelete" v-if="isAuth('alarmManager:changeDealMonitorRecord')">编辑</el-button>
        <el-button type="primary" @click="deleteForm" v-show="showEditAndDelete" v-if="isAuth('alarmManager:deleteDealMonitorRecord')">删除</el-button>
        <el-button type="primary" @click="resetForm" v-show="showExit" v-if="isAuth('alarmManager:recallDealMonitorRecord')">撤回</el-button>
        <el-button type="primary" @click="returnBtn">返回</el-button>
      </div>
      <div v-else-if="isExamineUrl&&!isSearchWarnUrl">
          <el-button type="warning" @click="Report" v-if="isAuth('alarmManager:reportLeader') && showDealStatus == 3">严重隐患上报</el-button>
          <el-button type="success" @click="coordinate" v-if="isAuth('alarmManager:leaderHandleReport')&& showDealStatus == 6 && leaderType == 0">已协调资源</el-button>
          <el-button type="success" @click="successForm" v-if="isAuth('alarmManager:notPassOrPassDealMonitorRecord')&& showDealStatus == 3">通过</el-button>
          <el-button type="danger" @click="exitForm" v-if="isAuth('alarmManager:notPassOrPassDealMonitorRecord')&& showDealStatus == 3">退回</el-button>
          <el-button type="danger" @click="Rectification" v-if="isAuth('alarmManager:leaderReturnReport')&& showDealStatus == 7">退回,继续整改</el-button>
          <el-button type="primary" @click="returnBtnExamine">返回</el-button>
      </div>
      <div v-else>
        <el-button type="primary" @click="returnBtnSearch">返回</el-button>
      </div>
    </div>
    <div class="main clearfix" :style="{height:basicHeight+'px'}">
      <el-row>
        <el-col :span="24">
          <div class="maindetails">
            <div class="item_info">
              <p><span>处理单编号:</span>{{infoFormData.alarmDealCode}}</p>
              <p><span>当前状态:</span>{{runStatus}}</p>
            </div>
            <div class="item_info">
              <p><span>监测点名称:</span>{{infoFormData.monitoringName}}</p>
              <p><span>监测点编号:</span>{{monitoringCode}}</p>
            </div>
            <div class="item_info">
              <p><span>创建时间:</span>{{infoFormData.createTime}}</p>
              <p><span>排故时间:</span>{{infoFormData.solveTime}}</p>
            </div>
            <div class="item_info">
              <p><span>提交时间:</span>{{infoFormData.submitTime}}</p>
              <p v-if="infoFormData.verifyTime"><span>审核时间:</span>{{infoFormData.verifyTime}}</p>
              <p v-else><span>审核时间:</span>--</p>
            </div>
            <div class="item_info">
              <p><span style="width: 93px">处理人员:</span> <el-select v-model="value" placeholder="请选择" :disabled="disabled" multiple>
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id">
                </el-option>
              </el-select></p>
              <p><span>填写人员:</span>{{infoFormData.writeName}}</p>
            </div>
            <div class="item_info" style="margin-bottom: 27px">
              <p style="position: relative">
                <span style="position: absolute;top: 0">照片附件:</span>
                <span class="all_img_container">
                  <viewer :images="photoId">
                    <span style="height: 80px;width: 80px;display: inline-block;margin-right: 10px;overflow: hidden" class="img_container" v-for="(items,indexs) in photoId" :key="indexs" @click="getIndexImg(indexs)">
                      <img :src="items" alt="" :data-title="(indexs+1)+'/'+allTotal">
                   </span>
                  </viewer>
                </span>
              </p>
              <div class="page_fixed" v-show="isShowPage">{{imgIndex}}/{{allTotal}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>报警故障描述</span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :rows="2"
                :disabled="disabled"
                placeholder="请输入内容"
                v-model="infoFormData.alarmRemark">
              </el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>报警原因分析</span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :rows="2"
                :disabled="disabled"
                placeholder="请输入内容"
                v-model="infoFormData.alarmReason">
              </el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>处理结果/对策</span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :disabled="disabled"
                :rows="2"
                placeholder="请输入内容"
                v-model="infoFormData.result">
              </el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>审核结果</span>
          </div>
          <div>
            <div class="warning_desi_data" v-if="isAuth('common:interface')">
              <div class="list_result" v-for="(item,index) in reason" :key="index" :class="{result_type:(index+1)==reason.length&&dealStatus==5}">
                <div class="clearfix">
                  <!-- <p style="font-weight: bold" v-if="(index+1)!=reason.length||dealStatus==4">{{item.userName}}: 退回</p> -->
                  <p style="font-weight: bold" v-if="item.dealStatus==4">{{item.userName}}: 退回</p>
                  <p style="font-weight: bold" v-else-if="item.dealStatus==5">{{item.userName}}: 通过</p>
                  <p style="font-weight: bold" v-else-if="item.dealStatus==6">{{item.userName}}: 严重隐患上报</p>
                  <p style="font-weight: bold" v-else-if="item.dealStatus==7">{{item.userName}}: 已协调资源</p>
                  <p style="font-weight: bold" v-else-if="item.dealStatus==8">{{item.userName}}: 退回,继续整改</p>
                  <!-- <p style="font-weight: bold" v-else>{{item.userName}}: 通过</p> -->
                  <p class="first_time">{{item.createTime}}</p>
                </div>
                <div v-if="(index+1)!=reason.length||dealStatus!=5">{{item.content}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <!--灭火瓶-->
          <div class="look_table_data table_data" v-if="deviceType==6">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="152"
                show-overflow-tooltip
                label="气压值(MPa)">
                <template slot-scope="scope">
                  <div>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column label="电池电量"  width="152">
               <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                  <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="205"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--液位-->
          <div class="look_table_data table_data" v-if="deviceType==3">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="152"
                show-overflow-tooltip
                label="液位值(m)">
                <template slot-scope="scope">
                  <div>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column label="电池电量"  width="152">
                        <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                  <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="205"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--烟感-->
          <div class="look_table_data table_data" v-if="deviceType==5">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="183">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="103">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">
                    <span v-if="scope.row.rcv == 1 || scope.row.rcv == 111">烟雾告警</span>
                    <span v-else-if="scope.row.rcv == 963">防拆告警</span>
                    <span v-else-if="scope.row.rcv == 986">高温告警</span>
                  </div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
            <el-table-column label="环境温度（℃）" min-width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.exField1">{{scope.row.exField1}}</div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column label="电池电量"  width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                  <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            <el-table-column label="信号强度"  width="103">
                <template slot-scope="scope">
                  <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                  <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="204"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--水浸-->
          <div class="look_table_data table_data" v-if="deviceType==7">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="203">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="203">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column label="电池电量"  width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                  <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            <el-table-column label="信号强度"  width="103">
                <template slot-scope="scope">
                  <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                  <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="204"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--用传-->
          <div class="look_table_data table_data" v-if="deviceType==8">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                prop="channelNo"
                label="设备编号"
                width="103" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="103">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="monitoringName"
                label="报警设备"
                width="203" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="location"
                label="报警地址"
                width="240" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="164"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--水压-->
          <div class="look_table_data table_data" v-if="deviceType==2">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="152">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="152"
                show-overflow-tooltip
                label="水压值(MPa)">
                <template slot-scope="scope">
                  <div>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="152"
                show-overflow-tooltip
                label="电池电量(V)">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">{{scope.row.battery}}</div>
                  <div v-else>{{scope.row.battery}}</div>
                </template>
              </el-table-column> -->
                                                    <el-table-column label="电池电量"  width="152">
                                           <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                    <!-- <el-table-column label="信号强度"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0" style="color: #f55353">无</div>
                                          <div v-else-if="scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column> -->
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="205"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--可燃气-->
          <div class="look_table_data table_data" v-if="deviceType==4">
            <el-table
              :data="tableData"
              stripe
              border
              style="width: 884px">
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="271">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="271">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
                                      <el-table-column label="信号强度"  width="90">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="181"
                label="记录时间">
                <template slot-scope="scope">
                  <div>{{scope.row.recordTime}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--电气-->
          <div class="look_table_data table_data" v-if="deviceType==1">
            <el-table
              :data="tableData"
              stripe
              border
              style="max-width: 1360px">
              <el-table-column
                type="index"
                label="序号"
                fixed
                width="70">
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                min-width="100"
                show-overflow-tooltip
                label="A相电流(A)">
                <template slot-scope="scope">
                  <div>{{scope.row.ia}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ib"
                min-width="100"
                show-overflow-tooltip
                label="B相电流(A)">
              </el-table-column>
              <el-table-column
                prop="ic"
                show-overflow-tooltip
                min-width="100"
                label="C相电流(A)">
              </el-table-column> -->
              <el-table-column
                prop="temp1"
                show-overflow-tooltip
                min-width="100"
                label="温度1(℃)">
              </el-table-column>
              <el-table-column
                prop="temp2"
                show-overflow-tooltip
                min-width="100"
                label="温度2(℃)">
              </el-table-column>
              <el-table-column
                prop="temp3"
                show-overflow-tooltip
                min-width="100"
                label="温度3(℃)">
              </el-table-column>
              <el-table-column
                prop="temp4"
                show-overflow-tooltip
                min-width="100"
                label="温度4(℃)">
              </el-table-column>
              <el-table-column
                prop="rcv"
                show-overflow-tooltip
                min-width="130"
                label="剩余电流(mA)">
              </el-table-column>
                                      <el-table-column label="信号强度"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 || scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                min-width="160"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="510px"
        class="reason_dialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        >
        <div class="exit_reason">请输入退回原因</div>
        <div><el-input
          type="textarea"
          :rows="2"
          maxlength="50"
          placeholder="不超过50个字符"
          v-model="textarea">
        </el-input></div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="confirmExit">确 定</el-button>
  </span>
      </el-dialog>

      
<!-- 严重隐患上报 -->
  <el-dialog
        title="请输入隐患上报原因"
        :visible.sync="dialogVisible5"
        width="510px"
        class="report_dialog"
        :close-on-click-modal="false">
        <div><el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          placeholder="最多不超过100个字符"
          v-model="reportForm.reportTextarea">
        </el-input></div>
         <div style="margin-top:20px;">
              <el-table
                class="user_table"
                ref="multipleTable"
                :data="reportData"
                tooltip-effect="dark"
                max-height="255px"
                style="width:100%;border:1px solid #e0e0e0;border-bottom:none;">
              <el-table-column
                width="413px"
                label="请选择上报领导"
                prop="userName"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column width="55" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheckbox" @change = 'handleSelectionChange(scope.row)'></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
         </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible5 = false">取 消</el-button>
            <el-button type="primary" @click="ReportExit">确 定</el-button>
        </span>
  </el-dialog>
<!-- 严重隐患上报 -->

<!-- 已协调资源 -->
  <el-dialog
        title="请输入资源协调说明"
        :visible.sync="dialogVisible6"
        width="510px"
        class="report_dialog"
        :close-on-click-modal="false">
        <div><el-input
          type="textarea"
          :rows="4"
          maxlength="100"
          placeholder="最多不超过100字符"
          v-model="coordinateTextarea">
        </el-input></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible6 = false">取 消</el-button>
            <el-button type="primary" @click="coordinateExit">确 定</el-button>
        </span>
  </el-dialog>
<!-- 已协调资源 -->

      
<!-- 退回，继续整改 -->
  <el-dialog
        title="请选择退回原因"
        :visible.sync="dialogVisible7"
        width="510px"
        class="report_dialog"
        :close-on-click-modal="false">
         <div>
              <el-table
                class="user_table"
                ref="multipleTable"
                :data="radioData"
                tooltip-effect="dark"
                max-height="255px"
                :show-header= 'false'
                style="width:100%;border:1px solid #e0e0e0;border-bottom:none">
              <el-table-column
                width="413px"
                prop="title"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column width="55" align="center">
                <template slot-scope="scope">
                  <el-radio v-model="radiochecked" :label="scope.row.title"  @change="radioChange"></el-radio>
                </template>
              </el-table-column>
            </el-table>
         </div>
         <div><el-input
          type="textarea"
          :disabled="isdisable"
          :rows="3"
          maxlength="100"
          placeholder="最多不超过100个字符"
          v-model="radioTxt">
        </el-input></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible7 = false">取 消</el-button>
            <el-button type="primary" @click="RectificationExit">确 定</el-button>
        </span>
  </el-dialog>
<!-- 退回，继续整改 -->
    </div>
  </div>
</template>

<script>
  import {ajaxFuncJson} from "../../api/ajax";
  import {uploadIp} from "../../api/ajax";
  export default {
    name:'searchForm',
    component:'',
    data(){
      return{
        reportData:[],
        dialogVisible5:false, //严重隐患上报
        dialogVisible6:false, //已协调资源
        dialogVisible7:false,
        reportForm:{ //严重隐患上报提交
          reportTextarea:'',
          reportcheked:[]
        },
        radiochecked:'',
        radioTxt:'',
        radioData:[{title:'隐患未完全解决'},{title:'隐患复杂,需重新解决'},{title:'隐患严重,已协调资源,继续解决'},{title:'其他'}],
        isdisable:true,
        coordinateTextarea:'',//协调资源输入框
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        tipTitle:'查看报警处理表单',
        firstTipTitle:'报警处理',
        total:0,
        monitorList:[],
        disabled:true,
        tableData: [],
        imgIndex:1,
        allTotal:1,
        isShowPage:false,
        photoId:[],
        textarea:'',
        page:1,
        warningData:false,
        options: [],
        monitoringCode:'',
        runStatus:'',
        value: [],
        reason:[],
        deviceType:'',    //设备类型
        dealStatus:'',
        isExamineUrl:false,   //是否从审核页面进入
        isSearchWarnUrl:false, //是否从告警综合页面进入
        basicHeight:"",
        params:{
          alarmDealRecordId:'',
          monitorId:sessionStorage.getItem('saveId'),
        },
        infoFormData:{

        },
        showEditAndDelete:false,
        showExit:false,
        exitReason:'',    //退回原因
        isFirst:1,
        dialogVisible:false,
        // clickIndex: sessionStorage.getItem('index'),
        showDealStatus:'',
        leaderType:''
      }
    },
    created() {
      this.leaderType = localStorage.getItem('leaderType');
      //从审核详情进入
      if(this.$route.query.searchUrl==='2-1'){
        this.tipTitle='审核报警处理表单';
        this.firstTipTitle='报警审核';
        this.isExamineUrl=true;
      }else if(this.$route.query.searchUrl==='3-1'){     //从综合查询详情页
        this.tipTitle='查看报警处理表单';
        this.firstTipTitle='综合查询';
        this.isSearchWarnUrl=true;
      }
      if(this.$route.query.type==='warnData'){
        if(sessionStorage.getItem('dealStatus')=='2'){
          this.showExit=true;
        }else if(sessionStorage.getItem('dealStatus')=='1'){
          this.showEditAndDelete=true;
        }
      }else {
        if(sessionStorage.getItem('dealStatus')=='3'){
          this.showExit=true;
        }else if(sessionStorage.getItem('dealStatus')=='2'||sessionStorage.getItem('dealStatus')=='4'||sessionStorage.getItem('dealStatus')=='8'){
          this.showEditAndDelete=true;
        }
      }
      this.params.alarmDealRecordId=this.$route.query.id;
      this.deviceType=this.$route.query.deviceType;
      if(this.isAuth('common:interface')){
        this.editSearchData();
      }
      if(this.isAuth('common:interface')){
        this.editSearchTable();
      }
      this.getExitFormData();

    },
    methods:{
      linkIndex(){
        if(this.$route.query.searchUrl==='2-1'){
          this.$router.push({path:'/content/indexExamine'})
        }else if(this.$route.query.searchUrl==='3-1'){
          this.$router.push({path:'/content/searchWarnIndex'})
        }else {
          this.$router.push({path:'/content/warningManger'})
        }
      },
      linkDetail(){
        if(this.$route.query.searchUrl==='2-1'){
          this.$router.push({path:'/content/warnExamine'})
        }else if(this.$route.query.searchUrl==='3-1'){
          this.$router.push({path:'/content/searchWarnDetail'})
        }else {
          this.$router.push({path:'/content/warnDetail'})
        }
      },
      ImgAutoContainer(Img,maxWidth,maxHeight){
        var image = new Image();
        //原图片原始地址（用于获取原图片的真实宽高，当<img>标签指定了宽、高时不受影响）
        image.src = Img.attr('src');
        image.onload=function () {
          if (maxWidth/ maxHeight  < image.width / image.height) //原图片宽高比例 大于 图片框宽高比例  100  50   100  20
          {

            Img.css({'width':'auto','height':'100%','left':-(image.width / image.height*80-80)/2+'px'});  //以框的宽度为标准

          }
          else {   //原图片宽高比例 小于 图片框宽高比例
            Img.css({'width':'100%','height':'auto','top':(image.width / image.height*80-80)/2+'px'});  //以框的高度为标准
          }
        };
      },
      //监听左右键
      listenKeyDown(){
        let _this=this;
        document.onkeydown=function(event){
          var e = event || window.event || arguments.callee.caller.arguments[0];
          if(e && e.keyCode==37){//上,左
            if(_this.imgIndex==1){
              _this.imgIndex=_this.allTotal;
            }else {
              _this.imgIndex=_this.imgIndex-1;
            }
          }
          if(e && e.keyCode==39){//下,右
            if(_this.imgIndex==_this.allTotal){
              _this.imgIndex=1;
            }else {
              _this.imgIndex=_this.imgIndex+1;
            }
          }
        };
      },
  //对处理图片进行绑定操作处理
      getIndexImg(index){
        this.imgIndex=index+1;
        this.isShowPage=true;
        this.preGetIndex();
        this.nextGetIndex();
        this.closePreImg();
        this.listenKeyDown();
      },
      preGetIndex(){
        $('body').off('click').on('click','.viewer-prev',this.preGetIndex1)
      },
      preGetIndex1(){
        if(this.imgIndex==1){
          this.imgIndex=this.allTotal;
        }else {
          this.imgIndex=this.imgIndex-1;
        }
      },
      closePreImg(){
        $('body').on('click','.viewer-close',this.closePreImg1);
      },
      closePreImg1(){
          this.isShowPage=false;
      },
      nextGetIndex(){
        $('html').off('click').on('click','.viewer-next',this.nextGetIndex1)
      },
      nextGetIndex1(){
        if(this.imgIndex==this.allTotal){
          this.imgIndex=1;
        }else {
          this.imgIndex=this.imgIndex+1;
        }
      },
      returnBtn(){ //返回按钮;
        this.$router.push({path:'/content/warnDetail'}); //报警处理
      },
      //返回综合查询详情
      returnBtnSearch(){
        sessionStorage.setItem('returnType','1');
        this.$router.push({path:'/content/searchWarnDetail'}); //报警处理
      },
      //获取告警单退回原因
      getExitFormData(){
        ajaxFuncJson('/alarmManager/getAlarmFallbackReason',this.params).then(res=>{
          if(res.data.status==200){
              this.reason=res.data.data;
          }
        })
      },
      //获取新增个人的信息
      getPersonData(){
        let params={
          monitorId: sessionStorage.getItem('saveId')
        };
        ajaxFuncJson('/alarmManager/getMonitorMessage',params).then(res=>{
          if(res.data.status==200){
            this.monitoringCode=res.data.data.monitoringCode;
            if(res.data.data.runStatus==1){
              this.runStatus='告警';
            }else if(res.data.data.runStatus==2){
              this.runStatus='预警';
            }else{
              this.runStatus='正常';

            }
          }
        })
      },
      handleCurrentChange(){

      },
      //编辑查看
      editSearchData(){
        ajaxFuncJson('/alarmManager/getAlarmSheet',this.params).then(res=>{
          if(res.data.status==200){
            let _this=this;
            this.infoFormData=res.data.data;
            this.options=res.data.data.managePeople;
            this.dealStatus=this.infoFormData.dealStatus;
            this.showDealStatus = this.infoFormData.dealStatus;
            if(this.infoFormData.handleId){
              this.value=this.infoFormData.handleId.split(',');
            }else{
               this.value=[];
            }
            if(this.infoFormData.photoId){
              this.photoId=this.infoFormData.photoId.split(',');
            }else{
              this.photoId=[];
            }
            this.allTotal=this.photoId.length;
            this.photoId.forEach((a,b)=>{
              this.photoId[b]=uploadIp()+'/file/filePreview/'+a;
            });
            this.$nextTick(()=>{
              $('.img_container').find('img').each(function (index,item) {
                _this.ImgAutoContainer($(this),80,80);
              })
            });
            if(this.isAuth('common:interface')){
              this.getPersonData();
            }
          }
        })
      },
      //相除时防止浮点数值转化
      accDiv(arg1,arg2){
        var t1=0,t2=0,r1,r2;
        try{
          t1=arg1.toString().split(".")[1].length;
        }catch(e){}

        try{
          t2=arg2.toString().split(".")[1].length;
        }catch(e){}
        r1=Number(arg1.toString().replace(".",""));
        r2=Number(arg2.toString().replace(".",""));
        return (r1/r2)*Math.pow(10,t2-t1);
      },
      //编辑查看表格
      editSearchTable(){
        this.params.type=this.deviceType;
        ajaxFuncJson('/alarmManager/getSelectDealMonitorRecord',this.params).then(res=>{
          if(res.data.status==200){
            this.tableData=res.data.data;
            if(this.deviceType==2){    //水压
              this.tableData.forEach((a,b)=>{
                this.tableData[b].rcv=this.accDiv(a.rcv,1000);
                this.tableData[b].battery=this.accDiv(a.battery,100); //四期数据处理
              })
            }else if(this.deviceType==3){   //液位
              this.tableData.forEach((a,b)=>{
                this.tableData[b].rcv=this.accDiv(a.rcv,100);
                this.tableData[b].battery=this.accDiv(a.battery,100); //四期数据处理
              })
            }
          }
        })
      },
      //删除告警单
      deleteForm(){
        this.$confirm('确定删除当前报警处理单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          closeOnPressEscape:false,
        }).then(() => {
            this.deleteAjax();
        }).catch(() => {

        });
      },
      //删除该表单
      deleteAjax(){
        let params={
          id:this.params.alarmDealRecordId,
          change:2,
          monitoringId:sessionStorage.getItem('saveId'),
        };
        ajaxFuncJson('/alarmManager/deleteDealMonitorRecord',params).then(res=>{
          if(res.data.status==200){
            this.$router.push({path:'/content/deleteSuccess'}); //删除成功
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      //撤回该表单
      withdrawAjax(){
        let params={
          id:this.params.alarmDealRecordId,
          change:3,
          type:this.deviceType,
          handleId:this.infoFormData.handleId,
          monitoringId:sessionStorage.getItem('saveId'),
        };
        ajaxFuncJson('/alarmManager/recallDealMonitorRecord',params).then(res=>{
          if(res.data.status==200){
            this.$router.push({path:'/content/withDrawSuccess'})
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      Report(){ //严重隐患上报*
        this.dialogVisible5 = true;
        this.ReportAjax();//获取校区领导
      },
      ReportAjax(){
        ajaxFuncJson('/alarmManager/getLeader',{}).then(res=>{
          if(res.data.status==200){
            this.reportData = res.data.data;
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      handleSelectionChange(val){ //隐患上报选择发生变化
            this.reportForm.reportcheked = []
            this.reportData.forEach((item,index)=>{
              if(item.isCheckbox){
                this.reportForm.reportcheked.push(item.id);
              }
            })
      },
      ReportExit(){ //隐患上报确定
        let params = {
          alarmDealId:this.params.alarmDealRecordId, //审核处理ID
          dealStatus:6, //处理状态;上报6
          leaderId:(this.reportForm.reportcheked).join(','),//领导id多个分隔， 上报需要穿领导ID
          monitoringId:sessionStorage.getItem('saveId'),//监测点id
          content:this.reportForm.reportTextarea //上报原因
        }
        if(params.leaderId == ''){
            this.$alert('请选择上报领导！', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {}
              });
        }else if(params.content == ''){
             this.$alert('请输入隐患上报原因！', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {}
              });
        }else{
          ajaxFuncJson('/alarmManager/reportLeader',params).then(res=>{ //隐患上报成功
            if(res.data.status==200){
               this.dialogVisible5=false;
               this.$router.push({path:'/content/exitSuccess',query:{type:'2'}})
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
        }
      },
      coordinate(){ //已协调资源
        this.dialogVisible6 = true;
      },
      coordinateExit(){//已协调资源确定
        let params = {
          alarmDealId:this.params.alarmDealRecordId, //审核处理ID
          dealStatus:7, //处理状态;协调7
          monitoringId:sessionStorage.getItem('saveId'),//监测点id
          content:this.coordinateTextarea //协调资源原因
        }
        if(params.content ==''){
             this.$alert('请输入资源协调说明！', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {}
              });
        }else{
          ajaxFuncJson('/alarmManager/leaderHandleReport',params).then(res=>{
            if(res.data.status==200){
              this.$router.push({path:'/content/warnExamine'}); //报警处理
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
        }
      },
      Rectification(){ //退回，继续整改
        this.dialogVisible7 = true;
      },
      radioChange(val){//退回选项发生变化
        if(val == '其他'){
          this.isdisable  = false;
        }else{
          this.isdisable  = true;
        }
      },
      RectificationExit(){ //退回继续整改确定
          let params = {
            alarmDealId:this.params.alarmDealRecordId, //审核处理ID
            dealStatus:8, //处理状态;退回
            monitoringId:sessionStorage.getItem('saveId'),//监测点id
            content:this.radiochecked //退回原因
          }
          if(this.radiochecked == '其他'){
             params.content = this.radioTxt;
          }
          if(params.content == ''){
             this.$alert('请选择退回原因！', '提示', {
                confirmButtonText: '我知道了',
                callback: action => {}
              });
          }else{
            ajaxFuncJson('/alarmManager/leaderReturnReport',params).then(res=>{
              if(res.data.status==200){
                 this.dialogVisible7=false;
                 this.$router.push({path:'/content/exitSuccess'})
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error',
                })
              }
            });
          }
      },
      successForm(){
        this.$confirm('确定通过此报警处理单的审核吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          closeOnPressEscape:false,
        }).then(() => {
          this.successFormAjax();
        }).catch(() => {

        });
      },
      successFormAjax(){
        let params={
          id:this.params.alarmDealRecordId,
          change:5,
          type:this.deviceType,
          monitoringId:sessionStorage.getItem('saveId'),
        };
        ajaxFuncJson('/alarmManager/notPassOrPassDealMonitorRecord',params).then(res=>{
          if(res.data.status==200){
            this.$router.push({path:'/content/examineSuccess',query:{url:'2-1'}})
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      exitForm(){
        this.dialogVisible=true;
      },
      confirmExit(){
        if(this.textarea){
          this.exitFormAjax(this.textarea)
        }else {
          this.dialogVisible=false;
          this.$alert('退回原因不能为空！', '提示', {
            confirmButtonText: '我知道了',
            callback: action => {
              this.dialogVisible=true;
            }
          });
        }
      },
      exitFormAjax(value){
        let params={
          id:this.params.alarmDealRecordId,
          change:4,
          type:this.deviceType,
          content:value,
          monitoringId:sessionStorage.getItem('saveId'),
        };
        ajaxFuncJson('/alarmManager/notPassOrPassDealMonitorRecord',params).then(res=>{
          if(res.data.status==200){
            this.dialogVisible=false;
            this.$router.push({path:'/content/exitSuccess'})
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      returnBtnExamine(){
        this.$router.push({path:'/content/warnExamine',query:{id:'123456'}})
      },
      //撤回该表单
      resetForm(){
        this.$confirm('确定撤回当前报警处理单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          closeOnPressEscape:false,
        }).then(() => {
          this.withdrawAjax()
        }).catch(() => {

        });
      },
      //点击编辑操作
      editForm(){
        this.$router.push({path:'/content/editForm',query:{type:'edit_add',deviceType:this.deviceType,id:this.params.alarmDealRecordId}})
      },
      //切换表格
      changeData(){
          this.warningData=!this.warningData;
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.basicHeight=$(window).height()-$('.mainHead').outerHeight(true)-81;
      });
    },
  }
</script>



<style scoped>
  .main{
   background: #fff;
    overflow: auto;
  }
  .main .maindetails{
    padding: 30px 0 0 70px;
  }
  .success_btn{
    background: #4BAE4F!important;
  }
  .router_link:hover{
    color:#198CFF;
    cursor: pointer;
  }
  .exit_reason{
    color: #282828;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .refuse_btn{
    background: #F55554!important;
  }
  .page_fixed{
    color: #fff;
    position: fixed;
    bottom: 40px;
    font-size: 24px;
    left: 50%;
    transform: translate(-50%,0);
    z-index: 6666;
  }
  .item_info{
  display: flex;
  margin-bottom: 35px;
  font-size: 14px;
  color: #282828;
}
.item_info p:nth-of-type(1){
  width: 490px;
}
.item_info p span{
  display: inline-block;
  width: 95px;
}
.warning_desi{
  padding: 13px 20px 10px 70px;
  color: #333;
  font-weight: 700;
}
  .warning_desi .crumbs{
    display: inline-block;
    width: 6px;
    height: 16px;
    background: #198cff;
    vertical-align: -3px;
    margin-right: 8px;
  }
  .warning_desi_data{
    padding-left: 70px;
    margin-bottom: 25px;
  }
  .list_result{
    /* padding: 15px 10px 5px 10px; */
    padding: 5px 10px 15px 10px;
    font-size: 13px;
    color: #282828;
    width: 883px;
    border: 1px solid #ffe0cb;
    border-radius: 2px;
    background: #FFF7E7;
    margin-bottom: 10px;
  }
  .list_result>div{
    margin-top: 10px;
  }
  .list_result p{
    float: left;
  }
  .list_result .first_time{
    float: right;
  }
 .result_type{
   background: #E8F8E9;
   border: 1px solid #8ae58d;
 }
  .look_table_data{
    padding-left: 70px;
    padding-bottom: 40px;
    margin-top: 15px;
  }
  .img_container img{
    width: 100%;
    height: auto;
    cursor: pointer;
    position: relative;
  }
  .all_img_container{
    padding-left: 95px;
    width: 800px!important;
  }
</style>


// WEBPACK FOOTER //
// src/page/warningManger/searchForm.vue